import { createSlice } from '@reduxjs/toolkit';

export const projectSlice = createSlice({
    name: "project",
    initialState: null,
    reducers: {
        set: (state, action) => {
            state = action.payload;
            return state;
        }
    }
})

export const projectActions = projectSlice.actions;

export default projectSlice.reducer;